import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { getAllBrandsKey } from "./useGetAllBrand";

type DeleteBrandArgs = {
    id: number;
    /**
     * When true, sends `?force=true` so the backend dissociates every linked
     * product (sets product.brand_id = NULL) before removing the brand. Used
     * by the "delete anyway" path of the in-use confirmation modal.
     */
    force?: boolean;
};

export const useBrandDelete = () => {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async ({ id, force = false }: DeleteBrandArgs) => {
            const url = force ? `/api/brands/${id}?force=true` : `/api/brands/${id}`;
            const response = await loggedInApiCall.delete(url);
            return response;
        },
        onSuccess: () => queryClient.invalidateQueries([getAllBrandsKey]),
    });

    return query;
};
